import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';

class IndexChartsSidebar extends Component {

    static propTypes = {
        path: PropTypes.string
    };

    static defaultProps = {
        path: '/charts'
    };

    state = {
        visible: true
    };


    componentWillMount = () => {
        this.sideMenuActivate();
    };

    componentDidMount = () => {
        window.addEventListener("resize", this.sideMenuActivate, false);
    };

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.sideMenuActivate, false);
    };

    sideMenuActivate = () => {
        if (window.matchMedia("(max-width: 640px)").matches) {
            this.setState({visible: false});
        } else {
            this.setState({visible: true});
        }
    };

    render() {

        return (
            <aside className="charts__sidebar">
                <button type="button" aria-label="Use the dropdown menu to navigate to a different page" aria-haspopup="true" aria-expanded="false" onClick={() => this.setState({visible: !this.state.visible})}>Charts <i className="fas fa-caret-down" aria-hidden="true" /></button>
                <ul className={this.state.visible ? 'sidebar__menu sidebar__menu--visible' : 'sidebar__menu'}>
                    <li className="sidebar__group">
                        <h3>CP+ BASI</h3>
                        <ul>
                            {/* <li><NavLink activeClassName="active" to={`${this.props.path}/CPP-basi/0`} onClick={() => this.setState({visible: false})}>Overall</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/CPP-basi/1`} onClick={() => this.setState({visible: false})}>Trade Size</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/CPP-basi/2`} onClick={() => this.setState({visible: false})}>Sector</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/CPP-basi/3`} onClick={() => this.setState({visible: false})}>Specialty</NavLink></li> */}
                            <li><NavLink activeClassName="active" to={`${this.props.path}/CPP-basi/4`} onClick={() => this.setState({visible: false})}>Corps & EM</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/CPP-basi/5`} onClick={() => this.setState({visible: false})}>Treasury</NavLink></li>
                        </ul>
                    </li>
                    {/* <li className="sidebar__group">
                        <h3>Trax BASI</h3>
                        <ul>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/trax-basi/0`} onClick={() => this.setState({visible: false})}>Europe</NavLink></li>
                        </ul>
                    </li> */}
                </ul>
            </aside>
        );
    }
}

export default IndexChartsSidebar;



// WEBPACK FOOTER //
// ./frontend/pages/IndexCharts/IndexChartsSidebar.jsx